import {
  buildPrintNELabelPath,
  BuildPrintNELabelPathProps,
} from './build-print-ne-label-path';

export const buildRechargeCallbackPath = (props: BuildPrintNELabelPathProps) =>
  `/admin/v2${buildPrintNELabelPath(props)}`;
